<div class='container' *ngIf='loadingState === loadingStates.LOADED; else loadingComponent'>
    <div class='mb-3 pt-3'>
        <div class='h3'>Account Payments Report</div>
        <p>Created: {{dateCreated}}</p>
    </div>
    <div class="d-flex align-items-center">
        <mat-chip class="tag fs-6 p-3" [selected]="this.reportType === reportTypes.ALL_TRANSACTIONS" (click)="onReportTypeSelected(reportTypes.ALL_TRANSACTIONS)">
            All transactions
        </mat-chip>
        <mat-chip class="tag fs-6 p-3 ms-3" [selected]="this.reportType === reportTypes.CANCELLED_SUBSCRIPTIONS" (click)="onReportTypeSelected(reportTypes.CANCELLED_SUBSCRIPTIONS)">
            Cancelled subscriptions
        </mat-chip>
    </div>
    <div *ngIf="this.reportType === reportTypes.CANCELLED_SUBSCRIPTIONS" class="d-flex align-items-center my-4">
        <div class="fs-6 me-2">Observe cancelled subscriptions since </div>
        <mat-chip class="tag fs-6 p-3" [selected]="this.churnRateOption === churnDateRanges.FOREVER" (click)="onChurnRateDateRangeSelected(churnDateRanges.FOREVER)">
            Forever
        </mat-chip>
        <div class="m-lg-2 fs-6">or</div>
        <mat-chip class="tag fs-6 p-3" [selected]="this.churnRateOption === churnDateRanges.LAST_SIX_MONTHS" (click)="onChurnRateDateRangeSelected(churnDateRanges.LAST_SIX_MONTHS)">
            Last 6 months
        </mat-chip>
        <div class="m-lg-2 fs-6">or</div>
        <mat-chip class="tag fs-6 p-3" [selected]="this.churnRateOption === churnDateRanges.LAST_YEAR" (click)="onChurnRateDateRangeSelected(churnDateRanges.LAST_YEAR)">
            Last 12 months
        </mat-chip>
        <div class="m-lg-2 fs-6">or select</div>
        <mat-chip class="tag fs-6 p-3" [selected]="this.churnRateOption === churnDateRanges.CUSTOM_DATE" (click)="onChurnRateDateRangeSelected(churnDateRanges.CUSTOM_DATE)">
            Custom date
        </mat-chip>
    </div>
    <div *ngIf="this.reportType === reportTypes.CANCELLED_SUBSCRIPTIONS && this.churnRateOption === churnDateRanges.CUSTOM_DATE" class="d-flex align-content-center m-lg-2">
        <div class="d-flex flex-row align-items-baseline">
        <div class="d-flex flex-column ms-5 align-content-center justify-content-center">
            <div class='h5' style="text-align: center">Quarters</div>
        </div>
        <div class="d-flex flex-row align-items-center ms-4 gap-2">
            <mat-chip class="tag fs-6 p-3" [selected]="this.customQuarter === quarters.Q1" (click)="onQuarterSelected(quarters.Q1)">
                Q1
            </mat-chip>
            <mat-chip class="tag my-3 fs-6 p-3" [selected]="this.customQuarter === quarters.Q2" (click)="onQuarterSelected(quarters.Q2)">
                Q2
            </mat-chip>
            <mat-chip class="tag  fs-6 p-3" [selected]="this.customQuarter === quarters.Q3" (click)="onQuarterSelected(quarters.Q3)">
                Q3
            </mat-chip>
            <mat-chip class="tag fs-6 p-3" [selected]="this.customQuarter === quarters.Q4" (click)="onQuarterSelected(quarters.Q4)">
                Q4
            </mat-chip>
        </div>
            <div class="d-flex flex-row gap-2 ms-5 align-content-center justify-content-center">
                <div class='h6' style="text-align: center">Year</div>
                <app-year-picker (yearSelected)="onChurnRateYearSelected($event)"></app-year-picker>
            </div>
        </div>
    </div>
    <div *ngIf="this.reportType === reportTypes.CANCELLED_SUBSCRIPTIONS" class='mt-5 mb-5'>
        <div class='h6'>Total accounts that bought a subscription and cancelled :  <b>{{getAccountsCancelledAndBoughtASubscription()}}</b></div>
        <div class='h6'>Total accounts :  <b>{{getTotalAccounts()}}</b></div>
        <div class='h4 mt-4'>Churn rate :  <b>{{getChurnRate()}}</b></div>
        <div class="mt-5 fs-6 lh-1">In the table below, the accounts that <b> cancelled</b> are shown with their first (oldest) subscription payment during the selected time range.</div>
    </div>
    <div *ngIf="this.reportType === reportTypes.ALL_TRANSACTIONS" class='mt-5 mb-5'>
        <div class='h6'>Total accounts that bought a subscription and cancelled :  <b>{{getAccountsCancelledAndBoughtASubscription()}}</b></div>
        <div class='h6'>Total accounts :  <b>{{getTotalAccounts()}}</b></div>
        <div class='h4 mt-4'>Churn rate :  <b>{{getChurnRate()}}</b></div>
    </div>
    <app-generic-admin-report-table *ngIf="this.reportType === reportTypes.ALL_TRANSACTIONS"
        [filter]='allTransactionsFilter'
        [columnData]='allTransactionsColumns'
        [loadingState]='loadingState'
        [dataSource]='allTransactionsDataSource'
        [viewModel]='allTransactionsViewModel'
        modelLabel='Payments'
        searchLabel='Search for Name, Email'
    ></app-generic-admin-report-table>
    <app-generic-admin-report-table *ngIf="this.reportType === reportTypes.CANCELLED_SUBSCRIPTIONS"
        [filter]='cancelledSubscriptionsFilter'
        [columnData]='cancelledSubscriptionsColumns'
        [loadingState]='loadingState'
        [dataSource]='cancelledSubscriptionsDataSource'
        [viewModel]='cancelledSubscriptionsViewModel'
        modelLabel='Accounts'
        searchLabel='Search for Name, Email'
    ></app-generic-admin-report-table>
</div>
<ng-template #loadingComponent>
    <div class="container mt-5 d-flex flex-column align-items-center justify-content-center">
        <mat-progress-bar class='container' [value]='loadingProgress'></mat-progress-bar>
        <div>Loading Report Table... {{loadingStatus}}%</div>
    </div>
</ng-template>
